import { Reveal } from "@/components/Reveal";
import { useUI } from "@/context/UIContext";
import { ArrowRight } from "lucide-react";

export function PageHero({ eyebrow, title, subtitle, image, tall = false }) {
  return (
    <section className={`relative flex items-end ${tall ? "min-h-[70vh]" : "min-h-[48vh]"} pt-24`} data-testid="page-hero">
      <div className="absolute inset-0">
        <img src={image} alt="" className="h-full w-full object-cover" loading="eager" />
        <div className="absolute inset-0 bg-gradient-to-t from-hp-dark via-hp-dark/70 to-hp-dark/30" />
        <div className="absolute inset-0 bg-gradient-to-r from-hp-dark/90 to-transparent" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 pb-14 w-full">
        {eyebrow && <p className="label-eyebrow mb-3">{eyebrow}</p>}
        <h1 className="font-display uppercase tracking-tight text-4xl sm:text-5xl md:text-6xl max-w-4xl leading-[0.98] text-white">{title}</h1>
        {subtitle && <p className="text-white/75 text-base sm:text-lg mt-5 max-w-2xl leading-relaxed font-light3">{subtitle}</p>}
      </div>
    </section>
  );
}

export function SectionTitle({ eyebrow, title, sub, center = false, onLight = false }) {
  return (
    <Reveal className={center ? "text-center max-w-3xl mx-auto" : "max-w-3xl"}>
      {eyebrow && <p className="label-eyebrow mb-3">{eyebrow}</p>}
      <h2 className={`font-display uppercase tracking-tight text-3xl sm:text-4xl md:text-5xl leading-tight ${onLight ? "text-hp-dark" : "text-white"}`}>{title}</h2>
      {sub && <p className={`text-base sm:text-lg mt-4 leading-relaxed font-light3 ${onLight ? "text-hp-dark/60" : "text-white/60"}`}>{sub}</p>}
    </Reveal>
  );
}

export function CTABand({ title = "Prêt à libérer la puissance de votre véhicule ?", sub = "Configurez votre véhicule ou demandez à être rappelé. Un conseiller Horsepower vous répond rapidement." }) {
  const { openLead } = useUI();
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 my-24" data-testid="cta-band">
      <div className="relative overflow-hidden bg-hp-yellow p-10 sm:p-14 rounded">
        <div className="relative flex flex-col lg:flex-row lg:items-center justify-between gap-8">
          <div className="max-w-2xl">
            <h2 className="font-display uppercase tracking-tight text-3xl sm:text-4xl text-hp-dark leading-tight">{title}</h2>
            <p className="text-hp-dark/70 mt-3 font-light3">{sub}</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <button onClick={() => openLead({ request_type: "rappel" })} className="bg-hp-dark text-hp-yellow font-display uppercase tracking-wide px-7 py-4 hover:bg-black transition-colors flex items-center justify-center gap-2 rounded-sm" data-testid="ctaband-rappel">
              Être rappelé <ArrowRight size={18} />
            </button>
            <button onClick={() => openLead({ request_type: "devis" })} className="border-2 border-hp-dark text-hp-dark font-display uppercase tracking-wide px-7 py-4 hover:bg-hp-dark hover:text-hp-yellow transition-colors rounded-sm" data-testid="ctaband-devis">
              Demander un devis
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
